import {useNavigate} from "react-router-dom";
import {post} from "../utils/post";
import {Button, Typography} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import * as React from "react";

export const ShouldRenew = () => {
    const navigate = useNavigate();

    const onRenew = async () => {
        const {invoice} = await post({method: "invoiceCreate", renew: true}, true);
        navigate(`/payment/${invoice.id}/`);
    }

    return (
        <div className={"page"}>
            <Typography variant={"h1"} align={"center"}>
                <ErrorOutlineIcon sx={{fontSize: 90}}/>
            </Typography>
            <Typography variant={"h4"} align={"center"} gutterBottom>
                Закончился период подписки!
            </Typography>
            <Typography variant={"h5"} align={"center"} gutterBottom>
                Необходимо продлить!
            </Typography>
            <br/>
            <Button id={"renewTariff"} variant={"contained"} onClick={onRenew}>Продлить</Button>
            <br/>
            <Button id={"chooseTariff"} onClick={() => navigate("/payment")}>Выбрать новый тариф</Button>
        </div>
    )
}
